import React, { useState } from 'react';
import { styles as st } from './Layout';

const VACIO = { password_actual: '', password_nueva: '', password_confirmar: '' };

export default function MiUsuario() {
  const [form, setForm] = useState(VACIO);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');

  const guardar = async (e) => {
    e.preventDefault();
    setError('');
    setExito('');
    if (form.password_nueva !== form.password_confirmar) {
      setError('La nueva contraseña y su confirmación no coinciden');
      return;
    }
    const r = await fetch('/api/perfil/password', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password_actual: form.password_actual, password_nueva: form.password_nueva }),
    });
    const d = await r.json();
    if (!r.ok) { setError(d.error || 'Error al actualizar la contraseña'); return; }
    setExito('Contraseña actualizada correctamente');
    setForm(VACIO);
  };

  return (
    <div style={st.card}>
      <h2 style={st.sectionTitle}>Usuario</h2>
      <form onSubmit={guardar} style={{ maxWidth: 360 }}>
        {error && <div style={{ color: '#dc2626', marginBottom: 10, fontSize: 13 }}>{error}</div>}
        {exito && <div style={{ color: '#16a34a', marginBottom: 10, fontSize: 13 }}>{exito}</div>}

        <label style={st.label}>Contraseña actual</label>
        <input
          type="password"
          style={st.input}
          value={form.password_actual}
          onChange={(e) => setForm({ ...form, password_actual: e.target.value })}
          required
        />

        <label style={st.label}>Nueva contraseña</label>
        <input
          type="password"
          style={st.input}
          value={form.password_nueva}
          onChange={(e) => setForm({ ...form, password_nueva: e.target.value })}
          required
          minLength={6}
        />

        <label style={st.label}>Confirmar nueva contraseña</label>
        <input
          type="password"
          style={st.input}
          value={form.password_confirmar}
          onChange={(e) => setForm({ ...form, password_confirmar: e.target.value })}
          required
          minLength={6}
        />

        <div style={{ marginTop: 20 }}>
          <button type="submit" style={st.btnPrimary}>Cambiar contraseña</button>
        </div>
      </form>
    </div>
  );
}
